import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './Blog.css';

const BlogPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogPost = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/blogs/${id}`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setBlog(data);
      } catch (err) {
        console.error("Error fetching blog post:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPost();
  }, [id]);

  if (loading) return <div className="loading-spinner">Loading...</div>;
  if (error) return <div className="error-message">Error: {error}</div>;
  if (!blog) return <div className="not-found">Blog post not found</div>;

  return (
    <>
      <Helmet>
        <title>{blog.title} | BooksComply Blog</title>
        <meta name="description" content={blog.description.replace(/<[^>]*>/g, '').substring(0, 160)} />

        {/* Open Graph meta tags */}
        <meta property="og:title" content={blog.title} />
        <meta property="og:description" content={blog.description.replace(/<[^>]*>/g, '').substring(0, 160)} />
        <meta property="og:image" content={`${process.env.REACT_APP_API_BASE_URL}/${blog.image}`} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="BooksComply" />

        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blog.title} />
        <meta name="twitter:description" content={blog.description.replace(/<[^>]*>/g, '').substring(0, 160)} />
        <meta name="twitter:image" content={`${process.env.REACT_APP_API_BASE_URL}/${blog.image}`} />
      </Helmet>

      <div className="blog-post-container">
        <div className="container">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-outline-primary back-button"
          >
            Back to Blog
          </button>

          <div className="card blog-card">
            {blog.image && (
              <img
                src={`${process.env.REACT_APP_API_BASE_URL}/${blog.image}`}
                alt={blog.title}
                className="card-img-top blog-image"
              />
            )}
            <div className="card-body">
              <h1 className="blog-title">{blog.title}</h1>

              <div
                className="blog-content"
                dangerouslySetInnerHTML={{ __html: blog.description }}
              />

              <div className="blog-category">Category: {blog.category}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BlogPost;